import { html } from "htm/preact";
import { useState, useEffect, useRef } from "preact/hooks";

// Fix z index not correct at first render
export default function MuxPauseButton() {
  // Controls which icon is shown (UI state only)
  const [paused, setPaused] = useState(false);

  // Ref to access the real DOM button
  const btnRef = useRef(null);

  useEffect(() => {
    const button = btnRef.current;
    if (!button) return;

    const handleClick = () => {
      // Locate mux-player and its underlying media element
      const hero = document.getElementById("hero-header");
      const media = hero?.querySelector("mux-player")?.media;
      if (!media) return;

      // Toggle playback
      if (media.paused) media.play().catch(() => { });
      else media.pause();

      // Update icon state
      setPaused(p => !p);
    };

    // Attach click listener once
    button.addEventListener("click", handleClick);
    return () => button.removeEventListener("click", handleClick);
  }, []);

  return html`
    <button ref=${btnRef}
     class="transition-colors p-2 text-white/50 hover:text-white data-paused:text-white lg:cursor-pointer"
     ...${paused ? { "data-paused": "" } : {}}>
      ${paused
      ? html`<svg class="size-8 fill-current stroke-current" xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100" role="img" aria-label="Play button">
        <circle cx="50" cy="50" r="49.5" fill="none" stroke-width="1" />
        <polygon points="38.2,32 38.2,68 70.6,50" />
      </svg>`
      : html`<svg class="size-8 fill-current stroke-current" xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100" role="img" aria-label="Pause button">
        <circle cx="50" cy="50" r="49.5" fill="none" stroke-width="1" />
        <rect x="37" y="30" width="8" height="40" />
        <rect x="55" y="30" width="8" height="40" />
      </svg>`}
    </button>
  `;
}